var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import { useInstanceRouting } from "./routing";
import CreateForm from "./CreateForm.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateInstance',
    props: {
        templateId: null
    },
    setup(__props) {
        const props = __props;
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.fetchTemplates();
        const { goToIndex } = useInstanceRouting();
        const template = computed(() => objectStoreTemplatesStore.getLatestTemplate(props.templateId));
        function onCreated(objectStore) {
            return __awaiter(this, void 0, void 0, function* () {
                const message = `Created storage location ${objectStore.name}`;
                goToIndex({ message });
            });
        }
        return { __sfc: true, objectStoreTemplatesStore, goToIndex, props, template, onCreated, CreateForm, LoadingSpan };
    }
});
